import { useState } from "react";

import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { RiFileExcel2Fill } from "react-icons/ri";
import { MdFilterList } from "react-icons/md";

import { Option } from "@/@types/generics/Option";

import { SearchInput } from "@/components/SearchInput";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";
import {
	accompanimentCitizenTypeIndicatorC3Options,
	AccompanimentCitizenTypeSelect,
} from "@/components/AccompanimentCitizenTypeSelect";

type IndicatorEsfC3CitizensVaccinationsFiltersProps = {
	search: string;
	setSearch: (search: string) => void;
	isEvaluated: boolean | undefined;
	setIsEvaluated: (isEvaluated: boolean | undefined) => void;
	handleExportTable: () => void;
};

export function IndicatorEsfC3CitizensVaccinationsFilters({
	search,
	setSearch,
	isEvaluated,
	setIsEvaluated,
	handleExportTable,
}: Readonly<IndicatorEsfC3CitizensVaccinationsFiltersProps>) {
	const defaultOption = accompanimentCitizenTypeIndicatorC3Options.find(
		(option) => option.value === isEvaluated
	);
	const [selectedOption, setSelectedOption] = useState<Option<boolean | undefined>>();
	const isAdvancedFilterEnabled = defaultOption?.value !== undefined;
	const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);

	function handleFilter() {
		setIsEvaluated(selectedOption?.value);
		setShowAdvancedFilter(false);
	}

	return (
		<Row className="d-flex align-items-center w-100 justify-content-between">
			<Col sm={12} md={12} lg={6} xl={6}>
				<div className="fw-bolder">Práticas de Vacinações</div>
			</Col>
			<Col sm={12} md={12} lg={4} xl={4}>
				<div className="d-flex align-items-center gap-2 w-100 justify-content-end">
					<div className="w-100 min-w-lg-300px max-w-lg-300px">
						<SearchInput
							placeholder="Buscar por nome, documento ou dt. nasc"
							value={search}
							setValue={setSearch}
							width={"100%"}
						/>
					</div>
					<CardOverlayTrigger
						show={showAdvancedFilter}
						setShow={setShowAdvancedFilter}
						header="Filtragem avançada"
						headerClassName="text-bolder fs-3"
						icon={
							<Button
								onClick={() => setShowAdvancedFilter(!showAdvancedFilter)}
								title="Filtro avançado"
								className="py-2 px-4 position-relative"
								variant="primary"
							>
								<MdFilterList className="fs-4" />
								{isAdvancedFilterEnabled && (
									<Badge
										bg="primary"
										pill
										className="position-absolute top-0 start-100 translate-middle py-0 px-1 border border-light rounded-circle"
									>
										&nbsp;
									</Badge>
								)}
							</Button>
						}
						trigger={["click"]}
						placement="bottom-end"
					>
						<div style={{ minWidth: "300px" }}>
							<Row className="mb-6">
								<Col>
									<AccompanimentCitizenTypeSelect
										defaultValue={defaultOption}
										value={selectedOption}
										onChange={(option) =>
											setSelectedOption(option as Option<boolean | undefined>)
										}
										options={accompanimentCitizenTypeIndicatorC3Options}
									/>
								</Col>
							</Row>
							<Row>
								<Col>
									<Button onClick={handleFilter}>Aplicar</Button>
								</Col>
							</Row>
						</div>
					</CardOverlayTrigger>
					<Button
						title="Exportar planilha"
						variant="success"
						className="py-2 px-4"
						onClick={handleExportTable}
					>
						<RiFileExcel2Fill />
					</Button>
				</div>
			</Col>
		</Row>
	);
}
